<ng-container *ngIf="showBanner">
  <div class="maintenance-banner">
    <div class="maintenance-banner__content">
      <div class="maintenance-banner__text">
        <ng-container *ngIf="bannerConfig">
          <p>
            <ng-container *ngIf="bannerConfig.bannerMessage; else defaultLine1">{{ bannerConfig.bannerMessage }}</ng-container>
            <ng-template #defaultLine1>We'll be carrying out scheduled maintenance from {{ bannerConfig.startTime | timeFormat }} {{ bannerConfig.startDate | dateFormat }} to {{ bannerConfig.endTime | timeFormat }} {{ bannerConfig.endDate | dateFormat }}.</ng-template>
            <span class="maintenance-banner__mobile-inline"> {{ bannerConfig.bannerSubMessage || "You won't be able to place orders online or by phone during that time." }} {{ bannerConfig.bannerThirdMessage || "We're sorry for any inconvenience this might cause." }}</span>
          </p>
          <p class="maintenance-banner__desktop-only">{{ bannerConfig.bannerSubMessage || "You won't be able to place orders online or by phone during that time." }}</p>
          <p class="maintenance-banner__desktop-only">{{ bannerConfig.bannerThirdMessage || "We're sorry for any inconvenience this might cause." }}</p>
        </ng-container>
      </div>
      <button class="maintenance-banner__close" (click)="closeBanner()" aria-label="Close banner">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </div>
</ng-container>
